/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics. 
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>cui-communication-service.interface.ts</name>
///
/// <description>
///  
/// </description>
///
/// <author>Michael Martinez</author>
/// <created>30 Aug 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 30Aug16 MM  1.0.0000         First cut
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import {Component } from  '@angular/core';
import { Observable } from 'rxjs/Observable';
import {Injectable, Input } from '@angular/core';

@Injectable()
export abstract class CUICommunicationServiceInterface  {
      
     
    abstract getDeviceViewModel(modelType: string, viewType: string): Observable<any>;   
    abstract getDevice(cid: string): Observable<any>;
    abstract updateDevice(deviceRequest: any): Observable<any>;
    
     
    

}
 


// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/interfaces/cui-communication-service.interface.ts